<template>
    <div>
      <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header p-2">
              <h6 class="modal-title">{{$t('Export')}}</h6>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
                <span aria-hidden="true">
                  <cancel-icon class="close-icon" style="height: 30px !important;
                    width: 30px !important;
                    color: #fff;">
                  </cancel-icon>
                </span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div style="overflow:auto;height: calc(100% - 34px) !important;" ref="generalTab">

                <div  class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                    <div>
                        <label>{{$t('Name')}}</label>
                    </div>
                    <input v-model="dstFileName" ref="dst_file_name_ref" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                </div>

                <div  class="common-input-field" :class="{readonlyDiv:Object.keys(globalSettingsFromStartup).includes('CATALOG_READ_ONLY') && globalSettingsFromStartup.CATALOG_READ_ONLY}" style="margin-inline-start: 2%;margin-top:8px;">
                    <label>{{$t('Catalog')}}
                        <span class="readonly-field ml-1" v-if="Object.keys(globalSettingsFromStartup).includes('CATALOG_READ_ONLY') && globalSettingsFromStartup.CATALOG_READ_ONLY">
                            ( non editable )
                        </span>
                    </label>
                    <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                        <div class="search-bar-comm-style" style="display: inline-flex;">
                        <catalog-dropdown ref="fcpxmlCatalogDropdownInput" 
                        :selectedOptions="fcpxmlCatalogs" 
                        :enableCatBrowser="Object.keys(globalSettingsFromStartup).includes('CATALOG_READ_ONLY') && globalSettingsFromStartup.CATALOG_READ_ONLY?false:true" style="width:100%;margin-inline-end: 6px;"
                        :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                        :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                        from="TagMetadata"></catalog-dropdown>
                        </div>
                    </div>
                </div>
                <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                    <div>
                        <label>{{$t('Path')}}</label>
                    </div>
                    <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                      <div style="display: inline-flex;">
                            <span v-if="!xmlExportPath" class="ml-0 mr-2 add-border" style="color: #4f4f4f; margin-inline-start: 0px !important;width: 100%;
                                padding: 8px 8px;
                                border-radius: 5px;
                                margin-bottom: 3px;">NONE</span>
                            <span v-else class="ml-4 mr-2 add-border" style="color: #f8f9fa; margin-inline-start: 0px !important;width: 100%;padding: 8px 8px;
                                border-radius: 5px;
                                margin-bottom: 3px;
                                overflow-wrap: anywhere;">{{xmlExportPath}}</span>
                            <browse-icon v-on:click="isActiveBinBrowse = true" style="height:26px;margin-inline-start:3px;position: relative;bottom: -4px;cursor:pointer;"></browse-icon>
                        </div>
                    </div>
                </div>
                
                <!-- <div v-if="fcpxmlExport === 'fcpxml_export'" class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                    <div>
                        <label>Path Prefix</label>
                    </div>
                    <input v-model="pathPrefix" ref="path_prefix_ref" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                </div> -->
              </div>
            </div>
            <div class="modal-footer primary-btn-style">
              <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click="close">{{$t('Cancel')}}</button>
              <button class="btn btn-outline-primary mr-3" style="border-color: #1d868c;background-color: #1d868c;color: #fff;" @click.prevent="createEditexportJob()">{{$t('Export')}}</button>
            </div>
          </div>
        </div>
      </div>
       <FolderBrowseModel ref="foldersBrowseModal"
        v-if="isActiveBinBrowse"
        :workspaceList="folderWorkspaceList"
        :enableAssetMultiSelect="false"
        @close="isActiveBinBrowse = false"
        @handleFilesBrowse="refreshBrowsedFolder"
        :enableRecursive="false"
        :browseOnlyFolders="true"
        style="z-index:99">
       </FolderBrowseModel>
    </div>
</template>

<script>
// import Multiselect from "vue-multiselect";
import Constants from "../../components.constants.js"
import Utils from "../../components.utils.js";
import browseIcon from "../core/InlineBrowseField.vue";
import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import FolderBrowseModel from "../files/filesBrowse.vue";
import cancelIcon from "../core/InlineCancelField.vue";
import {mapActions} from 'vuex';

export default {
  name:"growingMediaExportDialog",
  props:["projectId", "projectName","fileInfo"],
  data(){
    return{
        mediaNameObj: null,
        mediaNameList:[],
        folderWorkspaceList:[Constants.WORKSPACE_BINS],
        createExportJobPostData:{"job_name":"EditExport"},
        browseType:{path:''},
        isActiveBinBrowse:false,
        browseWorkspaceList:[Constants.WORKSPACE_BINS],
        dstPath:"",
        profileObj:[],
        profilesList:[],
        selectedCatalogsArr:null,
        dstFileName:"",
        pathPrefix:"",
        fcpxmlExport:"fcpxml_export",
        shortId: '',
        xmlExportPath:"",
        fcpxmlCatalogs:null,
    }
  },
  computed:{
    globalSettingsFromStartup:{
        get(){
          return this.$store.state.startUpData.startUpDataDetails;
        },
    },
  },
  components:{
    'cancel-icon':cancelIcon,
    "catalog-dropdown":CatalogDropdown,
    "browse-icon" : browseIcon,
    // Multiselect,
    FolderBrowseModel,
  },
  methods:{
    refreshBrowsedFolder(folderInfoList){
      if(folderInfoList && folderInfoList.length > 0){
        if(this.fcpxmlExport === 'fcpxml_export'){
          this.xmlExportPath = folderInfoList[0].path
        }else{
          this.dstPath = folderInfoList[0].path
        }
      }else{
        console.log("Failed to update the browsed folder path:",folderInfoList)
      }
      this.isActiveBinBrowse = false
    },
    generateShortId() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let shortId = '';
      for (let i = 0; i < 6; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        shortId += characters[randomIndex];
      }
      this.shortId = shortId;
    },

    createEditexportJob(){
        let payload = {params:{},asset_id:this.fileInfo._id || this.fileInfo.asset_id};
         if(this.dstFileName.length == 0){
            alert(this.$t("Name is empty")+".");
            return false;
          }
          var regex = /[!@^&()#$%*;':"\\|,<>/?]+/
          if (this.dstFileName.search(regex)>-1){
            alert("/:*;?!@^&()#\"<>$,|'%  are not supported")
            return false
          }

          payload.params['title'] = this.dstFileName;

          if(this.$refs.fcpxmlCatalogDropdownInput && Array.isArray(this.$refs.fcpxmlCatalogDropdownInput.searchKey) 
            && this.$refs.fcpxmlCatalogDropdownInput.searchKey.length){
              payload.params['xml_catalog_path'] = this.$refs.fcpxmlCatalogDropdownInput.getSelectedCatalogId();
          }else{
             alert(this.$t("Catalog path is empty")+".");
             return;
          }

          if(this.xmlExportPath){
              payload.params['xml_parent_path'] = this.xmlExportPath;
          }else{
             alert(this.$t("Path is empty")+".");
             return;
          }
          

        this.exportGrowingMediaFilesAsFCPXML(payload).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.close();
            this.$toast.success(this.$t("Export initiated"));
          } else {
            this.$toast.error(data.message);  
          }
        });
    },

    close(){
      this.$emit("close")
    },
    ...mapActions("assets",["exportGrowingMediaFilesAsFCPXML"]),
  },
  async created(){
    console.log("[Project Name]",this.projectName, this.projectId)
    this.dstFileName = this.projectName + "_{timestamp}";
  },
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #1d868c;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
$readOnly-bg-color: #1e2326 !important;
.modal-dialog {
    max-width: 470px;
    width: 470px;
    height: 567px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
     background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 6%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}
.modal-footer{
  padding: 5px 0px;
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:2%;
    justify-content: flex-end;
    button{
      height: 35px;
      width: 70px;
      font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}
.top-nav-bar{
    text-align: center;
    background: $primary-background;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

.common-input-field{
    margin-inline-start: 3%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $secondary-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}
.input-text-field{
    height: 44px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
    overflow: hidden;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}


input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: $secondary-border-color !important;
  }

  .add-border{
    border: $border-color;
  }

  .minMaxTextarea{
    min-height: 38px;
  }

  textarea:focus{
    outline: none;
    bottom: 0px;
    inset-inline-start: 0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
  }

  ::v-deep{
    .readonlyDiv{
        background: $readOnly-bg-color;
        pointer-events: none;
        border:none !important;
        label{
          width: 45%
        }
        .multiselect__tags{
          border: none !important;
          background: transparent !important;
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .tags-style{
      margin:5px;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
            width: 100%;
            height: unset !important;
            padding: 5px 40px 0 8px !important;
              .selected-tags-style{
                  margin : 0px !important;
                  margin-bottom: 5px !important;
                  margin-inline-end: 5px !important;
              }
            
        }
        .multiselect__placeholder {
            padding-top: unset !important;
            margin-bottom:0px;
            color:$dull-text-color !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
            height: unset !important;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px !important;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background;
            color:$dull-text-color;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:38px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
  }

  .dull-the-text{
    color: $dull-text-color;
  }

  ::placeholder {
    color: $dull-text-color !important;
  }
</style>
